import Divider from './Divider';
import FlipClock from './FlipClock';
import Group from './Group';
import Label from './Label';
import List from './List';
import ListItem from './ListItem';
import * as faces from './Faces';

export default {
    Divider,
    FlipClock,
    Group,
    Label,
    List,
    ListItem,
    faces
};
